import React from "react"

export default function ErrMessage({ isErr, errMsg }) {
  return (
    <>
      {isErr && (
        <div>
          <span className={"error-message"} style={{ display: "block", marginBottom: "5px" }}>
            {errMsg}
          </span>
        </div>
      )}
    </>
  )
}
